import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "text-lg-h6 text-smAndDown-body-1 text-right" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "app-membre-pagination"
}
const _hoisted_4 = { class: "text-body-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_coupon_loader = _resolveComponent("coupon-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_one_coupon_filter = _resolveComponent("one-coupon-filter")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_prop_driver_licence = _resolveComponent("prop-driver-licence")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_coupon_statistics = _resolveComponent("coupon-statistics")!
  const _component_one_coupon = _resolveComponent("one-coupon")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_coupon_report = _resolveComponent("coupon-report")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_modal_confirm_delete = _resolveComponent("modal-confirm-delete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_coupon_loader, { isLoading: _ctx.loading }, null, 8, ["isLoading"]),
    (_ctx.currentScanner)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 0,
          class: _normalizeClass({ 'app-membre-scanner': _ctx.currentScanner.isAppMembre })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              justify: "space-around"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              tile: "",
                              color: "success",
                              to: { name: 'Home' }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode(" mdi-arrow-left-bold ", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Retour au Menu", -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_1, [
                              _createTextVNode(_toDisplayString(_ctx.currentScanner.label) + " ", 1),
                              (_ctx.currentScanner.isAppMembre)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" (" + _toDisplayString(_ctx.paginationRange) + ") ", 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" (" + _toDisplayString(_ctx.unprocessedCoupons.length) + " coupon", 1),
                                    (_ctx.count > 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "s"))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" of " + _toDisplayString(_ctx.count) + ") ", 1)
                                  ], 64))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              align: "center",
              justify: "space-around"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    (_ctx.error)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 0,
                          border: "start",
                          density: "compact",
                          type: "error",
                          variant: "outlined",
                          class: "error text-center",
                          closable: "",
                          "close-label": "Close Alert"
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" Désolé, il est impossible de trouver des coupons pour l'instant. ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              align: "center",
              justify: "space-around"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { rounded: "0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            (_ctx.currentScanner.isAppMembre)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  align: "center",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6",
                                      lg: "5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.searchQuery,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                                          label: "Rechercher par n° de coupon, nom ou pocket",
                                          "prepend-inner-icon": "mdi-magnify",
                                          clearable: "",
                                          "hide-details": "",
                                          density: "compact",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, {
                              align: "end",
                              justify: "space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  lg: "10",
                                  class: _normalizeClass({ 'form-disabled': _ctx.batchId })
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_one_coupon_filter, {
                                      onFetch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTypeFilterFetch($event)))
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                (_ctx.unprocessedCoupons.length > 0 || _ctx.coupons.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12",
                                      lg: "2",
                                      class: "text-right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          block: "",
                                          color: "red lighten-1",
                                          variant: "outlined",
                                          disabled: _ctx.loading,
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteAll()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                _createTextVNode(" mdi-trash-can-outline ", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[15] || (_cache[15] = _createElementVNode("span", null, "Tout supprimer", -1))
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (
          !_ctx.currentScanner.isAppMembre &&
          (_ctx.unprocessedCoupons.length > 0 || _ctx.coupons.length > 0)
        )
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          rounded: "0",
                          ref: "driverLicenceContainer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_container, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  align: "center",
                                  justify: "space-between"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: _normalizeClass({ 'form-disabled': _ctx.batchId })
                                    }, {
                                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("small", null, "Entrez le permis de conduire et sélectionnez un véhicule pour commencer", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "12",
                                      class: _normalizeClass({ 'form-disabled': _ctx.batchId })
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_prop_driver_licence, {
                                                  label: "Driver Licence",
                                                  modelValue: _ctx.driverLicence,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.driverLicence) = $event)),
                                                  onLookup: _ctx.onceLookUp
                                                }, null, 8, ["modelValue", "onLookup"])
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.vehicles.length > 0)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "12",
                                                  md: "5"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      dense: "",
                                                      align: "center",
                                                      "align-content": "center",
                                                      justify: "space-between"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          lg: "7"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_select, {
                                                              modelValue: _ctx.vehicleId,
                                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vehicleId) = $event)),
                                                              items: _ctx.vehicles,
                                                              "item-title": _ctx.getVehicleName,
                                                              "item-value": "id",
                                                              variant: "outlined",
                                                              density: "compact",
                                                              "hide-details": "auto",
                                                              class: "vehicle-select"
                                                            }, null, 8, ["modelValue", "items", "item-title"])
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          lg: "5"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_btn, {
                                                              tile: "",
                                                              color: "deep-purple lighten-1 text-normal",
                                                              disabled: !_ctx.vehicleId,
                                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.applyToAll({ ..._ctx.driverLicenceData, vehicleId: _ctx.vehicleId })))
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                _createTextVNode(" Appliquer ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }, 8, ["disabled"])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["class"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.scVisible)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      style: _normalizeStyle({ height: _ctx.couponStatsHeight })
                    }, null, 8, ["style"]))
                  : _createCommentVNode("", true),
                (
          !_ctx.currentScanner.isAppMembre &&
          (_ctx.unprocessedCoupons.length > 0 || _ctx.coupons.length > 0)
        )
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_coupon_statistics, {
                          ref: "couponStats",
                          visible: _ctx.scVisible,
                          approvedTotal: _ctx.approvedTotal,
                          rejectedTotal: _ctx.rejectedTotal,
                          unprocessedTotal: _ctx.unprocessedTotal,
                          disableReport: !_ctx.vehicleId || _ctx.unprocessedCoupons.length > 0,
                          enableClear: _ctx.enableClear,
                          onComplete: _ctx.completeImport,
                          onClear: _ctx.clearScanner
                        }, null, 8, ["visible", "approvedTotal", "rejectedTotal", "unprocessedTotal", "disableReport", "enableClear", "onComplete", "onClear"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (_ctx.filteredItems.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                              return (_openBlock(), _createBlock(_component_one_coupon, {
                                key: item.id,
                                item: item,
                                "batch-id": _ctx.batchId,
                                "batch-data": {
              batchId: _ctx.batchId,
              driverId: _ctx.driverId,
              driverOdooId: _ctx.driverLicenceData?.driverId,
              odooDriverId: _ctx.odooDriverId,
              vehicleId: _ctx.vehicleId,
              fleetVehicleId: _ctx.fleetVehicleId,
              driverLicence: _ctx.driverLicence,
              vehicle: _ctx.vehicle,
            },
                                ref_for: true,
                                ref: "oneCoupon",
                                onDelete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmDeleteOne($event)))
                              }, null, 8, ["item", "batch-id", "batch-data"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "ma-12 text-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  rounded: "0",
                                  flat: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_container, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_item, null, {
                                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                            _createElementVNode("div", { class: "text-h6 mb-1" }, [
                                              _createElementVNode("p", null, [
                                                _createTextVNode(" Aucun coupon à afficher pour le moment. "),
                                                _createElementVNode("br"),
                                                _createTextVNode(" Essayez de modifier les filtres de coupon ci-dessus. ")
                                              ])
                                            ], -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_coupon_report, {
                  totalAmount: _ctx.approvedTotal.amount,
                  processedCount: _ctx.approvedTotal.total,
                  vehiclePlate: _ctx.vehicle || {},
                  driverLicence: _ctx.driverLicence,
                  "batch-id": _ctx.batchId
                }, null, 8, ["totalAmount", "processedCount", "vehiclePlate", "driverLicence", "batch-id"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.currentScanner?.isAppMembre)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-body-2 pagination-label" }, "Éléments par page :", -1)),
          _createVNode(_component_v_select, {
            "model-value": _ctx.pageSizeSelectModel,
            items: _ctx.pageSizeOptions,
            density: "compact",
            "hide-details": "",
            variant: "outlined",
            class: "page-size-select",
            disabled: _ctx.loading,
            "onUpdate:modelValue": _ctx.onPageSizeChange
          }, null, 8, ["model-value", "items", "disabled", "onUpdate:modelValue"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.paginationRange), 1),
          _createVNode(_component_v_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page) = $event)),
            length: Math.max(_ctx.listTotalPages, 1),
            "total-visible": 5,
            density: "comfortable",
            disabled: _ctx.loading
          }, null, 8, ["modelValue", "length", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedCoupons.length > 0)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 2,
          icon: "",
          class: "ma-12",
          size: "large",
          color: "red",
          position: "fixed",
          location: "bottom right",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmDeleteSelected())),
          style: {"z-index":"999"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_badge, {
              content: _ctx.selectedCoupons.length,
              color: "white",
              "text-color": "red"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "white" }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("mdi-trash-can", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_modal_confirm_delete, {
      "is-open": _ctx.confirmOpen,
      title: _ctx.deleteText.title,
      message: _ctx.deleteText.message,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirmOpen = false)),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteCallback(_ctx.deleteText.type)))
    }, null, 8, ["is-open", "title", "message"])
  ], 64))
}